import { render, staticRenderFns } from "./ItemRelatedItemsList.vue?vue&type=template&id=71cfb965&scoped=true"
import script from "./ItemRelatedItemsList.vue?vue&type=script&lang=ts"
export * from "./ItemRelatedItemsList.vue?vue&type=script&lang=ts"
import style0 from "./ItemRelatedItemsList.vue?vue&type=style&index=0&id=71cfb965&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cfb965",
  null
  
)

export default component.exports